import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import {useFormicForm} from 'TemplateEditor/Layout/Blocks'
import {ColorInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/ColorInput'
import {FontInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/FontInput'
import {SliderInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/SliderInput'
import {TextAlignInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/TextAlignInput'
import {TextInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/TextInput'
import {DefaultBlockConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockConfig'
import {DefaultBlockTopConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockTopConfig'
import {NormalTextConfigType} from 'TemplateEditor/Layout/Blocks/Text/NormalText'
import {TEMPLATE_EDITOR_ACTIVE_FORM_ID} from 'TemplateEditor/templateEditorFormId'

export function NormalTextConfig() {
  const {t} = useI18n()
  const {handleSubmit, values, setFieldValue} =
    useFormicForm<NormalTextConfigType>()

  return (
    <>
      <form id={TEMPLATE_EDITOR_ACTIVE_FORM_ID} onSubmit={handleSubmit}>
        <DefaultBlockTopConfig values={values} setFieldValue={setFieldValue} />

        <FontInput
          value={values.font}
          name={'font'}
          label={t('templateEditor.fontLabel')}
          setFieldValue={setFieldValue}
        />
        <TextInput
          value={values.value}
          name={'value'}
          label={t('templateEditor.textLabel')}
          setFieldValue={setFieldValue}
        />
        <ColorInput
          value={values.fontColor}
          name={'fontColor'}
          label={t('templateEditor.textColorLabel')}
          setFieldValue={setFieldValue}
        />
        <ColorInput
          value={values.fontBackground}
          name={'fontBackground'}
          label={t('templateEditor.textBackgroundColorLabel')}
          setFieldValue={setFieldValue}
        />
        <SliderInput
          value={values.fontSize}
          name={'fontSize'}
          label={t('templateEditor.textSizeLabel')}
          setFieldValue={setFieldValue}
          max={8}
          min={0.5}
          step={0.1}
        />
        <TextAlignInput
          value={values.align}
          name={'align'}
          label={t('templateEditor.textAlignLabel')}
          setFieldValue={setFieldValue}
        />

        <DefaultBlockConfig values={values} setFieldValue={setFieldValue} />
      </form>
    </>
  )
}
